import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { editorActions } from "store/editor";
import { createDocument } from "utils/editor";
import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "firebaseApp";
import { CODE_DOC_TYPE, MARKDOWN_DOC_TYPE } from "schemas/documents";
import CodeEditor from "./code-editor/CodeEditor";
import { COLLECTIONS } from "firebaseCollections";
import { Stack } from "@mui/material";
import MarkdownDocument from "./MarkdownDocument";
import MarkdownEditor from "./MarkdownEditor";

export default function ActiveDocument() {
  const auth = useAuth();
  const dispatch = useDispatch();
  const uid = auth.currentUser?.uid;

  const editorState = useSelector((state) => state.editor);

  const updateDocument = async (value) => {
    if (!editorState.activeDocument) {
      await createDocument(value, () => {}, uid, dispatch);
    } else {
      dispatch(editorActions.updateActiveDocument(value));
    }
  };

  const handelSave = async (content = null) => {
    if (editorState.activeDocument) {
      await updateDoc(
        doc(db, COLLECTIONS.mdDocuments, editorState.activeDocument.id),
        {
          content: content || editorState.activeDocument.content,
        }
      );
    }
  };

  const value = editorState.activeDocument
    ? editorState.activeDocument.content
    : "";

  const render = () => {
    if (
      !editorState.activeDocument ||
      editorState.activeDocument.type === MARKDOWN_DOC_TYPE
    ) {
      return (
        <MarkdownEditor
          value={value}
          initial={value}
          setValue={updateDocument}
          save={handelSave}
        />
        // <MarkdownDocument
        //   value={value}
        //   initial={value}
        //   setValue={updateDocument}
        //   save={handelSave}
        // />
      );
    }

    if (editorState.activeDocument.type === CODE_DOC_TYPE) {
      return (
        <CodeEditor
          documentId={editorState.activeDocument.id}
          value={value}
          setValue={updateDocument}
          save={handelSave}
        />
      );
    }
  };

  return (
    <Stack
      sx={{
        height: "100%", // This is the important change!
        width: "100%"
      }}
    >
      {render()}
    </Stack>
  );
}
